var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.179 16.8297C15.9949 17.8278 14.459 18.4303 12.7807 18.4303C9.03582 18.4303 6 15.4306 6 11.7303C6 8.02997 9.03582 5.03027 12.7807 5.03027C14.459 5.03027 15.9949 5.63277 17.179 6.63081C18.363 5.63277 19.8989 5.03027 21.5773 5.03027C25.3221 5.03027 28.358 8.02997 28.358 11.7303C28.358 15.4306 25.3221 18.4303 21.5773 18.4303C19.8989 18.4303 18.363 17.8278 17.179 16.8297Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.179 16.8297C18.6369 15.6008 19.5614 13.7722 19.5614 11.7303C19.5614 9.68832 18.6369 7.85972 17.179 6.63081C18.363 5.63277 19.8989 5.03027 21.5772 5.03027C25.3221 5.03027 28.3579 8.02997 28.3579 11.7303C28.3579 15.4306 25.3221 18.4303 21.5772 18.4303C19.8989 18.4303 18.363 17.8278 17.179 16.8297Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.179 16.8297C18.6369 15.6008 19.5614 13.7722 19.5614 11.7303C19.5614 9.68835 18.6369 7.85976 17.179 6.63086C15.7211 7.85976 14.7966 9.68835 14.7966 11.7303C14.7966 13.7722 15.7211 15.6008 17.179 16.8297Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardIcon);
export default __webpack_public_path__ + "static/media/mastercard-icon.8ac8d2244a707b08e8b8e0d6f82552d6.svg";
export { ForwardRef as ReactComponent };